import axios from "axios";
import { expireIframeSession, isInIframe } from "./utils/authSession";

// export const BASE_API_URL = "https://dev-greenback-app-cms-gateway.azurewebsites.net/cms";
// export const BASE_API_URL = "https://prod-greenback-app-cms-gateway.azurewebsites.net/cms";
// export const BASE_API_URL = "https://dev-greenback-app-tenants.azurewebsites.net/api";
// export const BASE_API_URL = "https://dev-greenback-app-tenants-agent-tester-danilo.azurewebsites.net/api"; // Updated to point to Shopify OAuth service
// export const BASE_API_URL = "https://localhost:6001/api";

export const BASE_API_URL = process.env.REACT_APP_CMS_API_URL;

const getApiKey = () => {
  return process.env.REACT_APP_FIREBASE_API_KEY;
};

const refreshAuthToken = async () => {
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) return null;

  try {
    const response = await axios.post(
      `https://securetoken.googleapis.com/v1/token?key=${getApiKey()}`,
      new URLSearchParams({
        grant_type: "refresh_token",
        refresh_token: refreshToken,
      }),
      { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
    );

    const { id_token, refresh_token } = response.data;
    localStorage.setItem("authToken", id_token);
    localStorage.setItem("refreshToken", refresh_token);
    return id_token;
  } catch {
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    return null;
  }
};

let isRefreshing = false;
let pendingRequests = [];

export const createAuthenticatedAxiosInstance = (baseURL) => {
  const instance = axios.create({ baseURL });

  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("authToken");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        config.headers["t-api-key"] = token;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      if (error.response?.status === 401 && !originalRequest._retry) {
        if (isInIframe()) {
          expireIframeSession();
          return Promise.reject(error);
        }

        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            pendingRequests.push({ resolve, reject });
          }).then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            originalRequest.headers["t-api-key"] = token;
            return instance(originalRequest);
          });
        }

        originalRequest._retry = true;
        isRefreshing = true;

        try {
          const newToken = await refreshAuthToken();
          if (newToken) {
            pendingRequests.forEach(({ resolve }) => resolve(newToken));
            pendingRequests = [];
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            originalRequest.headers["t-api-key"] = newToken;
            return instance(originalRequest);
          }
        } catch {
          pendingRequests.forEach(({ reject }) => reject(error));
          pendingRequests = [];
        } finally {
          isRefreshing = false;
        }

        localStorage.removeItem("authToken");
        localStorage.removeItem("refreshToken");
        window.location.href = "/";
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

const axiosInstance = createAuthenticatedAxiosInstance(BASE_API_URL);

export default axiosInstance;
